var styles = {"Container":"g-4ozWstdhk-","Dialog":"AF0RCeS7ePI-","Overlay":"TbDgSIgs410-","input":"h8Cax1VLlz0-","inputError":"_11cB7mSzTWc-"};

export { styles as default };
//# sourceMappingURL=Prompt.module.css.js.map
